import React from 'react';
import { Link } from 'react-router-dom';

const Header = ({ toggleSidebar }) => {
  return (
    <header className="bg-gray-800 text-white shadow fixed top-0 left-0 w-full h-16 z-20 flex items-center justify-between px-4">
      <button
        className="block text-gray-800 focus:outline-none"
        onClick={toggleSidebar}
      >
        ☰
      </button>
      <h1 className="text-xl font-bold">Admin Panel - OpenCallForArtists</h1>
      <Link to="/logout" className="bg-red-900 text-white px-8 py-2 rounded-2xl hover:bg-gray-500 focus:outline-none">
        Logout
      </Link>
    </header>
  );
};

export default Header;
